interface ApiError {
    response?: {
        status?: number
    }
}

export const isBranchNotFoundError = (error: unknown) => {
    return (error as ApiError | undefined)?.response?.status === 404
}
